import { Static, Type } from '@sinclair/typebox';

export const ProfessionalHolidayItemSchema = Type.Object({
  public_holiday_id: Type.Number(),
  name: Type.String(),
  date: Type.String({
    format: 'date-time',
    meta: { is_short: true, with_time: false },
  }),
  formatted_date: Type.String(),
  country_code: Type.String(),
  is_enabled: Type.Boolean(),
  professional_holiday_id: Type.Union([Type.Number(), Type.Null()]),
});

export type ProfessionalHolidayItemObject = Static<typeof ProfessionalHolidayItemSchema>;

export const GetProfessionalHolidaysResponseSchema = Type.Array(ProfessionalHolidayItemSchema);
export type GetProfessionalHolidaysResponseObject = Static<typeof GetProfessionalHolidaysResponseSchema>;

export const PROFESSIONAL_HOLIDAY_STATE = {
  ON: 'on',
  OFF: 'off',
  MIXED: 'mixed',
} as const;

export type ProfessionalHolidayStateValue =
  (typeof PROFESSIONAL_HOLIDAY_STATE)[keyof typeof PROFESSIONAL_HOLIDAY_STATE];

export const ProfessionalHolidayStateEnum = Type.Union([
  Type.Literal(PROFESSIONAL_HOLIDAY_STATE.ON),
  Type.Literal(PROFESSIONAL_HOLIDAY_STATE.OFF),
  Type.Literal(PROFESSIONAL_HOLIDAY_STATE.MIXED),
]);

export const MergedProfessionalHolidayItemSchema = Type.Object({
  public_holiday_id: Type.Number(),
  name: Type.String(),
  date: Type.String({
    format: 'date-time',
    meta: { is_short: true, with_time: false },
  }),
  formatted_date: Type.String(),
  country_code: Type.String(),
  state: ProfessionalHolidayStateEnum,
});

export type MergedProfessionalHolidayItemObject = Static<typeof MergedProfessionalHolidayItemSchema>;

export const GetMergedProfessionalHolidaysResponseSchema = Type.Array(MergedProfessionalHolidayItemSchema);
export type GetMergedProfessionalHolidaysResponseObject = Static<typeof GetMergedProfessionalHolidaysResponseSchema>;

export const UpdateProfessionalHolidayItemSchema = Type.Object({
  public_holiday_id: Type.Number(),
  is_enabled: Type.Boolean(),
});

export const UpdateProfessionalHolidaysSchema = Type.Object({
  team_member_id: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
  holidays: Type.Array(UpdateProfessionalHolidayItemSchema, { minItems: 1 }),
});

export type UpdateProfessionalHolidaysObject = Static<typeof UpdateProfessionalHolidaysSchema>;
